
import React from "react";
import { Schemes } from "../../../utils";
import { i18nManager } from "../../../i18n";
import { Elements } from "../../shared/Elements";
import { Siren } from "../../shared/ConfirmDialog";
import { Button, Checkbox, Classname, Form } from "@rivtn/noseur";
import LoadingGif from "../../../assets/images/loading_circle.gif";
import { BaseService, ConsusService, IMember, IProfileWebsite, MemberService, SanitizedResponse } from "../../../services";

export interface MerchProps {
    profile: IMember;
    noCompound?: boolean;
    updateSettings: (enableRivtnAd: boolean) => void;
    enableRivtnAdState: [boolean | undefined, React.Dispatch<React.SetStateAction<boolean | undefined>>];
}

function Merch(props: MerchProps) {

    const [enableRivtnAd, _] = props.enableRivtnAdState;
    const labels = i18nManager.Labels.account.profile_website.merch;

    if (props.noCompound) return renderMerch();

    return (<div className="account-setting">
        <div className="header">
            <span className="title">{i18nManager.Labels.account.profile_website.title} - {labels.title}</span>
        </div>
        {renderMerch()}
    </div>);

    function renderMerch() {
        return (<Form scheme={Schemes.OMNEHOST} className={Classname.build("profile-settings", { "team-settings": props.noCompound })}>
            <Checkbox label={labels.enable_ad} defaultChecked={enableRivtnAd} onChange={(e: any) => {
                props.updateSettings(e.checked);
            }} />
            <hr />
            <Button scheme={Schemes.OMNEHOST} text={labels.connect_store} loadingProps={Elements.BUTTON_LOADING_PROPS}
                style={{ marginBottom: 20 }} onClick={(e) => {
                    e.manageRef?.setLoadingState(true);

                }} />
            <Button scheme={Schemes.OMNEHOST} text={labels.manage_store} loadingProps={Elements.BUTTON_LOADING_PROPS}
                style={{ marginBottom: 20 }} onClick={(e) => {
                    e.manageRef?.setLoadingState(true);

                }} />
            <span style={{ marginTop: 10 }}>{labels.preview}</span>
            <iframe className="preview-iframe" src={window.location.protocol + "//" + window.location.host} />
        </Form>);
    }

}

export default Merch;
